import AbstractSlopedRectangle from "./AbstractSlopedRectangle";

export default class SlopedRectangle extends AbstractSlopedRectangle {
	static NAME = "sloped-rectangle";

	get_name() {
		return SlopedRectangle.NAME;
	}
}
